import styled, {css} from "styled-components";

const PriorityCellStyled = styled.td`
  font-weight: bold !important;
  ${props => props.isEscalated && css`
    color: rgb(255, 0, 0) !important;
  `}
`;

export default PriorityCellStyled;